import "./App.css";
import "./styles/bootstrapAndSidebar.scss";
import "./styles/styles.scss";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/Header";
import AdminRoute from "./features/AdminRoute";
import Login from "./features/Login";
import React from "react";
import Customer from "./features/Common/customer/Customer";
import PrivateRoute from "../src/components/PrivateRoute";
import { Routes, Route, Navigate } from "react-router-dom";
import { store } from "./reducer/Store";
//import Home from "./features/Common/Home"; Homescreen not used anymore
import OperationsTrade from "./features/Common/operations/OperationsTrade";
import SuiviClient from "./features/Common/SuiviClient";
import RapportPdf from "./features/Common/RapportPdf";
import RapportPdf2 from "./features/Common/RapportPdf2";
import PlansTrade from "./features/Common/plans-trade/PlansTrade";
//import ChallengesTrade from "./features/Common/challenges/ChallengesTrade";
import PdfExport from "./features/Common/PdfExport";
import ExportXls from "./features/Common/ExportXls";
import DownloadPdf from "./features/Common/DownloadPdf";

function App() {
  const { state } = React.useContext(store);
  return (
    <div className="main-wrapper">
      {state.isAuth && <Header />}
      <main
        className={`${
          state.isAuth ? "main-container" : "main-container-login"
        } container-fluid`}
      >
        <Routes>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/login/*" element={<Login />}></Route>
          <Route
            path="/"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <Customer />
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/client"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <Customer />
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/operations"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <OperationsTrade />
              </PrivateRoute>
            }
          ></Route>
          {/*
          <Route
            path="/challenges"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <ChallengesTrade />
              </PrivateRoute>
            }
          ></Route>
          */}
          <Route
            path="/rapports-pdf"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <RapportPdf />
              </PrivateRoute>
            }
          ></Route>
           <Route
            path="/rapports-pdf2"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <RapportPdf2 />
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/suivi-client"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <SuiviClient />
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/plans-trade"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <PlansTrade />
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/export-pdf"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <PdfExport />
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/download-pdf/:pdfName"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <DownloadPdf />
              </PrivateRoute>
            }
          ></Route>
          {/*
          <Route
            path="/export-xls"
            element={
              <PrivateRoute roles={[1, 2, 3]}>
                <ExportXls />
              </PrivateRoute>
            }
          ></Route>
          */}
          <Route
            path="/admin/*"
            element={
              <PrivateRoute roles={[1, 2]}>
                <AdminRoute />
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="*"
            element={
              <PrivateRoute roles={[1, 2, 3, 4, 5, 6]}>
                <Navigate to="/client" replace />
              </PrivateRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;
